import { Eject } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, Dialog, DialogActions, DialogTitle, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '../../util/ErrorUtil';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class LiberarProcessosApreciadosLote extends ReactComponent {
    dialogOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            processos: computed,
            processosSelecionados: computed,
            limparProcessoPesquisa: action,
            mensagemLoteSemProcessos: computed,
            handleClickBotaoLiberar: action,
            liberarProcessosSelecionados: action,
            renderConteudoDialog: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen,
                () => this.limparProcessoPesquisa()
            )
        );
    }

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    get processos() {
        return (this.salaSessaoStore.processosApreciadosFiltrados || []).filter(
            (registro) => registro.liberadoParaGabinete === false && this.filtrarProcessoPeloNumero(registro)
        );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosSelecionaveis() {
        return this.processos.filter((registro) => !registro.necessitaImportacaoSalaSessao);
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get mensagemLoteSemProcessos() {
        return (
            'Não há processos apreciados pendentes de liberação para o gabinete na sessão' +
            this.complementoMensagemFiltrando
        );
    }

    handleClickBotaoLiberar = async () => {
        await this.liberarProcessosSelecionados();
    };

    async liberarProcessosSelecionados() {
        let processosNotificar = this.processosSelecionados.slice();
        await this.salaSessaoStore.processarLote({
            titulo: 'Liberando processos',
            qtdTotalProcessos: this.processosSelecionados.length,
            lotesProcessos: this.processosSelecionados,
            funcaoOperacao: this.liberarProcessoGabinete
        });
        this.salaSessaoStore.notificarJulgamentoLote(processosNotificar);
        this.sessaoStore.atualizarListaProcessos();
    }

    liberarProcessoGabinete = async (registro) => {
        let resultadoProcessamento = await this.processoService.liberarProcessoGabinete(registro);
        this.salaSessaoStore.incrementarProgressoLote();

        if (resultadoProcessamento && !ErrorUtil.isResultadoErro(resultadoProcessamento)) {
            runInAction(() => (registro.liberadoParaGabinete = true));
        }

        return resultadoProcessamento;
    };

    getAlertasProcesso = (registro) => {
        let alertas = [];
        if (registro.necessitaImportacaoSalaSessao) {
            alertas.push({ mensagem: 'Processo não importado para sala de sessão', impeditivo: true });
        }
        return alertas;
    };

    render() {
        if (!this.isComponenteHabilitado('LiberarProcessosApreciadosLote') || !this.salaSessaoStore?.existeSessaoSIJ) {
            return null;
        }

        return (
            <>
                <div
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Liberar processos apreciados em lote'}
                        placement="top-start"
                    >
                        <Eject
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            onClick={this.handleClickIcone}
                        />
                    </Tooltip>
                </div>
                {this.dialogOpen && (
                    <Dialog
                        open
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        {this.renderDialogTitle}
                        {this.renderConteudoDialog}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={this.handleClickBotaoLiberar}
                                color="primary"
                                variant="outlined"
                                endIcon={<Eject />}
                                disabled={!this.processosSelecionados || this.processosSelecionados.length === 0}
                            >
                                Liberar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }

    get renderDialogTitle() {
        return (
            <DialogTitle style={{ padding: '16px 24px 0px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            flexGrow: 1
                        }}
                    >
                        <h4 style={{ margin: '0px' }}>Liberar processos apreciados em lote</h4>
                        <div style={{ margin: '0px 10px' }}>
                            <NumeroProcesso
                                dense
                                tooltip="Número do processo a ser pesquisado na listagem"
                                callbackOnChange={this.callbackNumeroProcesso}
                                clickLimpar={this.limparProcessoPesquisa}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', margin: '10px', paddingTop: '5px' }}>
                                <PainelFiltros />
                            </div>
                            <FiltroRapido id="filtroRapidoLiberarProcessosApreciadosLote" />
                        </div>
                    </div>
                </div>
            </DialogTitle>
        );
    }

    get renderConteudoDialog() {
        return (
            <>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    alertasProcessos={this.alertasProcessos}
                />
            </>
        );
    }
}

export default inject('stores')(observer(LiberarProcessosApreciadosLote));
